import React, { Component } from "react";

class Form_Pins extends Component {
  render() {
    return <React.Fragment>"Dit is de form voor Pins"</React.Fragment>;
  }
}

export default Form_Pins;
